import { Controller } from "@hotwired/stimulus"

// Polls the campaign's generation JSON (CampaignsController#generation) while Serin writes the
// creatives, keeps the elapsed time fresh and reloads the page once the generation is over —
// creatives attached and the queue building, or the campaign held with the reason.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 10000 } }
  static targets = ["elapsed"]

  connect() {
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!res.ok) return
      const data = await res.json()
      if (!data.active) { window.location.reload(); return }
      if (this.hasElapsedTarget && data.elapsed_text) this.elapsedTarget.textContent = data.elapsed_text
    } catch {
      // network hiccup: the next tick tries again
    }
  }
}
